module.exports = __webpack_public_path__ + "img/10.21808a91.png";